/*!
 * KoliBri - The accessible HTML-Standard
 */
import { g as watchString } from './common-D-vggmh2.js';

const validateCustomClass = (component, value) => {
    watchString(component, '_customClass', value, {
        defaultValue: '',
    });
};

export { validateCustomClass as v };
//# sourceMappingURL=custom-class-BtoZpwyq.js.map

//# sourceMappingURL=custom-class-BtoZpwyq.js.map